import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import withMobileDialog from "@material-ui/core/withMobileDialog";

import RecordPagination  from "../../utils/RecordsPagination";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import {appHelpers} from "../../_helpers";
import {appConstants} from "../../_constants";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  tableStyle: {
    padding: 0
  },
  tableHeader: {
    color: appConstants.REGIONAL_COLOR
  }
};

const TransitTableStructure = ({ classes, records,filterAirport}) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
                <TableCell className={classes.tableHeader} padding="none">Airline</TableCell>
                <TableCell className={classes.tableHeader}>Flight Number</TableCell>
                <TableCell className={classes.tableHeader} >Flight Date</TableCell>
                <TableCell className={classes.tableHeader} padding="none">Departure Airport</TableCell>
                <TableCell className={classes.tableHeader} padding="none">Destination Airport</TableCell>
                <TableCell className={classes.tableHeader} padding="none">Passenger Count</TableCell>
                <TableCell className={classes.tableHeader} padding="none">Total Passenger <br/>Count</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            { records.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell padding="none" className={'text-capitalize'}>
                            {item.Airline}
                        </TableCell>
                        <TableCell>
                            {item.FlightNumber}
                        </TableCell>
                        <TableCell>
                            {(item.DepartureDate) ? appHelpers.formatDate(item.DepartureDate, "MMM DD, YYYY") : ""}
                        </TableCell>
                        <TableCell padding="none">
                            {filterAirport(item.DepartureAirportCode)}
                        </TableCell>
                        <TableCell padding="none">
                            {filterAirport(item.DestinationAirportCode)}
                        </TableCell>
                        <TableCell padding="none">
                            {appHelpers.numberWithCommasOnly(item.PassengerCount)}
                        </TableCell>
                        <TableCell padding="none">
                            {appHelpers.numberWithCommasOnly(item.TotalDepartedPassengerCount)}
                        </TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);

class TransitTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, totalCounts,
        records, currentPage, pageSize, fetchMore, filterAirport}  = this.props;
    return (
      <div>
          <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
              <RecordPagination fetchMore={fetchMore} totalCount={totalCounts} pageSize={pageSize} currentPage={currentPage} target={<TransitTableStructure classes={classes} records={records} filterAirport= {filterAirport}/>}/>
          </div>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(TransitTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/Transit/TransitTable.jsx